import { ICommunityResource } from '@/types/admin/resources';

export const getResourceItemCount = (resource: ICommunityResource): number => {
  return [
    ...(resource.files || []),
    ...(resource.url ? [resource.url] : []),
    ...(resource.content ? [resource.content] : []),
  ].length;
};


